import React, { memo, forwardRef } from "react";
const SvgSingleBond = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M7 16a1 1 0 011-1h16a1 1 0 110 2H8a1 1 0 01-1-1z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgSingleBond.displayName = "SvgSingleBond";
const MemoForwardRef = memo(SvgSingleBond);
export default MemoForwardRef;
